import Vue from 'vue';
import Router from 'vue-router';
import login from '@/views/login';
import index from '@/views/index';
import statistics from '@/views/charts/statistics';
import user from '@/views/system/user';
import detail from '@/views/system/userDetail/detail';
import deliveryOrder from '@/views/system/deliveryOrder';
import orderDetail from '@/views/system/orderDetail/detail';
import school from '@/views/system/school';
import postStation from '@/views/system/postStation';
import dorm from '@/views/system/dorm';
import coupon from '@/views/system/coupon';
import infomercial from '@/views/system/infomercial';
import information from '@/views/system/information';
import houseList from '@/views/rentalSystem/houseList';
import rentalOrders from '@/views/rentalSystem/orders';
import servicePackage from '@/views/rentalSystem/servicePackage';
import dashboard from '@/views/home/dashboard';
import rentList from '@/views/housing/rentList';
import saleList from '@/views/housing/saleList';
import visitList from '@/views/housing/visitList';
import intentList from '@/views/housing/intentList';
import buyIntentList from '@/views/housing/buyIntentList';
import forumList from '@/views/housing/forumList';
import cityList from '@/views/housing/cityList';

Vue.use(Router);

export default new Router({
  routes: [{
    path: '/',
    name: '',
    component: login,
    hidden: true,
    meta: { requireAuth: false }
  }, {
    path: '/login',
    name: '登录',
    component: login,
    hidden: true,
    meta: { requireAuth: false }
  }, {
    path: '/index',
    name: '首页',
    component: index,
    iconCls: 'el-icon-tickets',
    children: [
      {
        path: '/home/dashboard',
        name: '数据看板',
        component: dashboard,
        meta: { requireAuth: true }
      },
      {
        path: '/housing/rent',
        name: '租赁房源',
        component: rentList,
        meta: { requireAuth: true }
      },
      {
        path: '/housing/sale',
        name: '买卖房源',
        component: saleList,
        meta: { requireAuth: true }
      },
      {
        path: '/housing/visit',
        name: '预约看房',
        component: visitList,
        meta: { requireAuth: true }
      },
      {
        path: '/housing/intent',
        name: '卖房意向',
        component: intentList,
        meta: { requireAuth: true }
      },
      {
        path: '/housing/buyIntent',
        name: '买房意向',
        component: buyIntentList,
        meta: { requireAuth: true }
      },
      {
        path: '/housing/forum',
        name: '论坛帖子',
        component: forumList,
        meta: { requireAuth: true }
      },
      {
        path: '/housing/city',
        name: '开通城市',
        component: cityList,
        meta: { requireAuth: true }
      },
      {
        path: '/system/user',
        name: '用户管理',
        component: user,
        meta: { requireAuth: true }
      },
      {
        path: '/system/information',
        name: '账号信息',
        component: information,
        meta: { requireAuth: true }
      },
      {
        path: '/system/userDetail/detail',
        name: '用户管理详情',
        component: detail,
        hidden: true,
        meta: { requireAuth: true }
      },
      {
        path: '/charts/statistics',
        name: '旧首页数据',
        component: statistics,
        hidden: true,
        meta: { requireAuth: true }
      },
      {
        path: '/system/deliveryOrder',
        name: '快递订单管理',
        component: deliveryOrder,
        hidden: true,
        meta: { requireAuth: true }
      },
      {
        path: '/system/orderDetail/detail',
        name: '快递详情',
        component: orderDetail,
        hidden: true,
        meta: { requireAuth: true }
      },
      {
        path: '/system/school',
        name: '学校管理',
        component: school,
        hidden: true,
        meta: { requireAuth: true }
      },
      {
        path: '/system/postStation',
        name: '驿站管理',
        component: postStation,
        hidden: true,
        meta: { requireAuth: true }
      },
      {
        path: '/system/dorm',
        name: '宿舍楼管理',
        component: dorm,
        hidden: true,
        meta: { requireAuth: true }
      },
      {
        path: '/system/coupon',
        name: '优惠卷管理',
        component: coupon,
        hidden: true,
        meta: { requireAuth: true }
      },
      {
        path: '/system/infomercial',
        name: '广告管理',
        component: infomercial,
        hidden: true,
        meta: { requireAuth: true }
      },
      {
        path: '/rentalSystem/houseList',
        name: '旧房源列表',
        component: houseList,
        hidden: true,
        meta: { requireAuth: true }
      },
      {
        path: '/rentalSystem/orders',
        name: '旧租房订单',
        component: rentalOrders,
        hidden: true,
        meta: { requireAuth: true }
      },
      {
        path: '/rentalSystem/servicePackage',
        name: '随心住服务包',
        component: servicePackage,
        hidden: true,
        meta: { requireAuth: true }
      }
    ]
  }]
})



// WEBPACK FOOTER //
// ./src/router/index.js